import React from "react";

import arrowBtn from '../../../assets/tutorial/icon_show_hide.svg'
import mouse from '../../../assets/tutorial/icon_mouse.svg'
import mouse_spark from '../../../assets/tutorial/icon_mouse_spark.svg'

interface Props {
  isCollapsed: boolean;
  showTutorial: boolean;
  setIsCollapsed: (boolean: any) => void;
  setShowTutorial: (boolean: any) => void;
}

const SidebarCollapser: React.FC<Props> = ({ isCollapsed, showTutorial, setIsCollapsed, setShowTutorial}) => {
  
  return (
    <div className={`tour-sidebar-collapse-container ${isCollapsed ? 'collapsed':''}`}>
      <div className={`tour-sidebar-collapse-btn ${isCollapsed ? 'collapsed':''}`} onClick={() => {setIsCollapsed(!isCollapsed); setShowTutorial(false)}}>
        <img src={arrowBtn} alt=''/>
      </div>
      <div className={`tour-sidebar-collapse-tutorial ${showTutorial ? '':'hide'}`}>
      <div className='tour-sidebar-collapse-animation-icon-container'>
        <img src={mouse_spark} alt='' className='tour-sidebar-collapse-icon-animation'/>
        <img src={mouse} alt='' className='tour-sidebar-collapse-icon'/>
      </div>
      <div className={`tour-sidebar-collapse-tutorial-text`}>
        <div className='tour-sidebar-collapse-animation-text-reduced'>
          Haz clic para mostrar las configuraciones
        </div>
      </div>
      </div>
    </div>
  );
};

export default SidebarCollapser;